import { createHttpClient as r, getErrorMapper as p } from "@systemeio/util";
const t = r();
t.interceptors.response.use((e) => e, p(t));
t.interceptors.response.use((e) => e.data);
export {
  t as httpClient
};
